import React from 'react';
import { Handle, Position } from 'reactflow';

class NodeValue extends React.Component {
  render() {
    return (
      <>
        <div className="dndnode input">
          Set Values to field
        </div>
        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
      </>
    );
  }
}

export default NodeValue;
